export default "<p *ngIf=\"showAgricultureText\" tabindex=\"1\" appFocusAccessibility>{{ 'confirmation.confirmationAgriculture' | translate }}</p>\n"